import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";

import { INotification } from "../../shared/interfaces/notification";

interface IProps {
  snacks: INotification[];
  onClose: (snack: INotification) => void;
}

/** Срок показа снека: столько же, сколько было по умолчанию у notistack. */
export const SNACK_AUTO_HIDE_DURATION = 5000;

/** Высота снека с зазором — на неё поднимается каждый следующий в стопке. */
const SNACK_HEIGHT = 60;
const STACK_BOTTOM_OFFSET = 24;

export const SnackbarStack = (props: IProps): JSX.Element => {
  const { snacks, onClose } = props;

  return (
    <>
      {snacks.map((snack, index) => (
        <Snackbar
          key={snack.id}
          open
          autoHideDuration={SNACK_AUTO_HIDE_DURATION}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          sx={{
            bottom: `${index * SNACK_HEIGHT + STACK_BOTTOM_OFFSET}px !important`,
          }}
          // клик мимо снека его не закрывает — как было в notistack
          onClose={(_event, reason: SnackbarCloseReason) => {
            if (reason !== "clickaway") {
              onClose(snack);
            }
          }}
        >
          <Alert
            severity={snack.severity}
            onClose={() => onClose(snack)}
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};
